export const GET_DATA_ENPS_WATCHER =
  "app/WidgetRightChartEnps/GET_DATA_ENPS_WATCHER"
export const GET_DATA_ENPS_SUCCESS =
  "app/WidgetRightChartEnps/GET_DATA_ENPS_SUCCESS"
export const GET_DATA_ENPS_FAILED =
  "app/WidgetRightChartEnps/GET_DATA_ENPS_FAILED"
